import React, { useState, useEffect } from "react";
import "./Home.css";

function Home() {
  // State untuk countdown timer
  const [timeRemaining, setTimeRemaining] = useState(calculateTimeRemaining());
  const [isVisible, setIsVisible] = useState(false);

  // Hitung waktu mundur ke 25 Januari 2025
  function calculateTimeRemaining() {
    const eventDate = new Date("2025-05-24T00:00:00"); // Tanggal event
    const currentTime = new Date();
    const timeDiff = eventDate - currentTime;

    if (timeDiff <= 0) {
      return { days: 0, hours: 0, minutes: 0, seconds: 0 };
    }

    const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((timeDiff / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((timeDiff / (1000 * 60)) % 60);
    const seconds = Math.floor((timeDiff / 1000) % 60);

    return { days, hours, minutes, seconds };
  }

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeRemaining(calculateTimeRemaining());
    }, 1000);

    // Trigger animation after component mounts
    setIsVisible(true);

    return () => clearInterval(timer);
  }, []);

  const { days, hours, minutes, seconds } = timeRemaining;

  const handleOrderButtonClick = () => {
    window.open("https://bmsbrothers.com", "_blank");
  };

  /*
  const handleFunRunOrderClick = () => {
    window.open("https://be-benz.id", "_blank");
  };
  */

  return (
    <div className="home">
      {/* Hero Section */}
      <div className="hero-container">
        <img
          src={`${process.env.PUBLIC_URL}/images/hero2.jpg`}
          alt="Hero"
          className="hero-image"
        />
        <div className="hero-content">
          <img
            src={`${process.env.PUBLIC_URL}/images/bms.png`}
            alt="Hero Logo"
            className="hero-image"
          />
        </div>
      </div>

      {/* Welcome Message */}
      <div className="welcome-message">
        <p className="background">
          Welcome to the official website of bmsbrothers-live.com, where you can
          learn about our event organizing services.
        </p>
        <p className="paragrafstyle">Our Event Organizing Services :</p>
        <ul className={`animate-list ${isVisible ? "visible" : ""}`}>
          <li className="fade-item">
            <p>Football Watch Party | Nobar</p>
          </li>
          <li className="fade-item">
            <p>Family Gathering | Corporate Gathering</p>
          </li>
          <li className="fade-item">
            <p>Launch Ceremony for Products and Services</p>
          </li>
          <li className="fade-item">
            <p>Music Concert Event</p>
          </li>
          <li className="fade-item">
            <p>Event Production</p>
          </li>
          <li className="fade-item">
            <button className="order-button" onClick={handleOrderButtonClick}>
              Other Services
            </button>
          </li>
        </ul>
      </div>

      {/* Countdown Timer Section */}
      {/*
      <div className="logo-container-countdown">
        <div className="countdown-timer">
          <p className="funrun-header" style={{ fontSize: "2rem" }}>
            UPCOMING EVENTS
          </p>
          <ol className={`animate-list ${isVisible ? "visible" : ""}`}>
            <li className="fade-item">
              <p style={{ textAlign: "left" }}>
                ANNIVERSARY MERCEDES BENZ W204
              </p>
            </li>
          </ol>

          <div className="funrun-image-container">
            <img
              src={`${process.env.PUBLIC_URL}/images/w204.jpeg`}
              alt="Fun Run Event"
              className="countdown-image"
            />
          </div>

          <button className="funrun-order-button">
            Tickets will be available for sale in April 2025
          </button>

          <p>
            Time Remaining: {days} Days, {hours} Hours, {minutes} Minutes,{" "}
            {seconds} Seconds
          </p>
        </div>
      </div>
      */}
      {/* Recent Events */}
      <h2 className="guest-star-heading">Recent Events</h2>
      <div className="guest-star">
        <div className="guest-star-container full-width">
          <img
            src={`${process.env.PUBLIC_URL}/images/w204.jpeg`}
            alt="Guest Star"
            className="guest-star-image"
          />
          <div className="guest-star-overlay"></div>
          <div className="guest-star-text">
            <p>Anniversary Mercedes Benz W204</p>
          </div>
        </div>
      </div>
      <div className="guest-star">
        <div className="guest-star-container full-width">
          <img
            src={`${process.env.PUBLIC_URL}/images/funrun.jpg`}
            alt="Guest Star"
            className="guest-star-image"
          />
          <div className="guest-star-overlay"></div>
          <div className="guest-star-text">
            <p>Anniversary Mercedes Benz W211</p>
          </div>
        </div>
      </div>
      <div className="guest-star">
        <div className="guest-star-container full-width">
          <img
            src={`${process.env.PUBLIC_URL}/images/gatheringsch24.JPG`}
            alt="Guest Star"
            className="guest-star-image"
          />
          <div className="guest-star-overlay"></div>
          <div className="guest-star-text">
            <p>Employee Gathering 2024</p>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="logo-container">
        <p>Copyright | BMS Brothers-live | 2024</p>
      </div>
    </div>
  );
}

export default Home;
